import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useEffect, useState } from 'react';
export default (function (_ref) {
  var eventName = _ref.eventName,
    getFunction = _ref.getFunction,
    manager = _ref.manager,
    _ref$ssr = _ref.ssr,
    ssr = _ref$ssr === void 0 ? true : _ref$ssr;
  var _useState = useState(ssr ? getFunction() : null),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var onChange = useCallback(function () {
    setValue(getFunction());
  }, [manager, getFunction]);
  useEffect(function () {
    var newValue = getFunction();
    if (newValue !== value) {
      setValue(newValue);
    }
    if (manager) {
      manager.on(eventName, onChange);
      return function () {
        manager.off(eventName, onChange);
      };
    }
  }, [manager, onChange]);
  return value;
});